module.exports = __webpack_public_path__ + "static/media/DSCF0258-z2poiYgs.d196f4d8.JPG";